export default class FileUpload {

	constructor(element, {
        maximum = 5,
		fileSize = 5,
		sizeUnit = 1048576,
        url = ''
    } = {}) {

        this._element = element;
        this._options = {
            maximum,
			fileSize,
			sizeUnit,
            url
        };

        this.init();
    }
	
    init() {
		const filePickBoxes = [...this._element.querySelectorAll('[data-file-picker]')];
		if (filePickBoxes && filePickBoxes.length > 0) {
			const maxFileSize = this._options.fileSize * this._options.sizeUnit;
			this._filepickers = filePickBoxes.map((f)=>this.setupFilePicker(f, maxFileSize));
			this._filepickers[0]?.fileinput?.setAttribute('required', true);
		}
    	this._addButton = this._element.querySelector('[data-file-add] button');
    	this._addButton.addEventListener('click', () => this.addFilePicker());
	}

	rearrange(filepicker) {
		const currentPicker = this._filepickers.find(pickerBox => pickerBox.filepicker == filepicker);
		const activePickers = this._filepickers.filter((({filepicker:picker}) => picker && !picker.classList.contains('t-hidden')));
		if (activePickers && activePickers.length > 0) {
			const {length, [length - 1]:last} = activePickers;
			if (length > 1) {
				filepicker.classList.add('t-hidden');
				this._filepickers = [...this._filepickers.filter(pickerBox => pickerBox.filepicker != filepicker),currentPicker];
				this._addButton.insertAdjacentElement('beforebegin', filepicker);
				this._addButton.classList.remove('t-hidden');
				this._filepickers.forEach(({fileinput}) => {
					if (fileinput.value && fileinput.value.length > 0) {
						fileinput.setAttribute('required', true);
					} else {
						fileinput.removeAttribute('required');
					}
				});
				if (this._filepickers[0].fileinput) {
					this._filepickers[0].fileinput.setAttribute('required', true);
				}
			} else {
				if (last.fileinput) {
					last.fileinput.setAttribute('required', true);
				}
			}
		}
	}

	displayNotChosen(fp) {
		if (fp.filenameLabel) {
			fp.filenameLabel.innerHTML = fp.filenameLabel.getAttribute('data-empty');
			if (fp.fileinputView && fp.fileinputView.classList.contains('c-file-upload__choice--made')) {
				fp.fileinputView.classList.remove('c-file-upload__choice--made');
			}
		}
	}

	setupFilePicker(filePickerBox, maxFileSize = 5242880) {
		return function (f, rearrange) {
			const fileinput = f.querySelector('input[type=file]');
			const fileinputHolder = f.querySelector('[data-file-upload-input]');
			const fileinputView = f.querySelector('[data-input-file-view]');
			const filenameLabel = f.querySelector('[data-input-file-name]');
			const fileremove = f.querySelector('[data-input-file-remove]');
			let selectedFiles;
			const handleChange = (e) => {
				let fileName = '';
				if (fileinput.files.length > 0) {
					if (fileinput.files[0].size > maxFileSize) {
						// Check the constraint
						fileinput.setCustomValidity("The selected file must not be larger than 5 MB");
						fileinput.validate?.(true);
						fileinput.value = "";
						return;
					}
					fileinput.setCustomValidity("");
				}

				if (fileinput.value && fileinput.value.length > 0) {
					fileName = fileinput.value.split( '\\' ).pop();
				} else if (selectedFiles) {
					fileinput.files = selectedFiles;
				}

				fileinput.setAttribute('required', true);
				fileinput.blur();
				if (fileName && filenameLabel) {
					filenameLabel.innerHTML = fileName;
					if (fileinputView && !fileinputView.classList.contains('c-file-upload__choice--made')) {
						fileinputView.classList.add('c-file-upload__choice--made');
					}
				}
			}
			const handleRemove = (e) => {
				if (fileinput.value && fileinput.value.length > 0) {
					fileinput.value = '';
				}
				rearrange(f);
				if (filenameLabel) {
					filenameLabel.innerHTML = filenameLabel.getAttribute('data-empty');
					if (fileinputView && fileinputView.classList.contains('c-file-upload__choice--made')) {
						fileinputView.classList.remove('c-file-upload__choice--made');
					}
				}	
			}
			
			const handleClick = (e) => {
				fileinput.removeAttribute('required');
				fileinput.setCustomValidity("");
				if (fileinput.value && fileinput.value.length > 0) {
					selectedFiles = fileinput.files;
				}
				fileinputHolder.classList.remove('-has-error');
			}
			
			if (fileinput) {
				fileinput.addEventListener( 'change', handleChange);
				fileinput.addEventListener( 'click', handleClick);
				fileinput.addEventListener( 'cancel', () => {
					fileinput.setAttribute('required', true);
				});
			}
			if (fileremove) {
				fileremove.addEventListener('click', handleRemove);
			}
			return {
				filepicker: f,
				fileinput,
				fileinputHolder,
				fileinputView,
				filenameLabel,
				fileremove
			}
		}(filePickerBox, (f) => this.rearrange(f));
	}

	async addFilePicker() {
		const activePickers = this._filepickers.filter((({filepicker}) => filepicker && !filepicker.classList.contains('t-hidden')));
		const nextPickers = this._filepickers.filter((({filepicker}) => filepicker && filepicker.classList.contains('t-hidden')));

		if (!activePickers || activePickers.length === 0) {
			return;
		}
		if (nextPickers && nextPickers.length > 0) {
			const {0:firstNext, length} = nextPickers;
			const {length:l, [l - 1]:lastActive} = activePickers;

			if (activePickers.length === 1) {
				lastActive.fileinput.setAttribute('required', true);
				lastActive.fileinput.validate?.();
			}
			
			if (!lastActive.fileinput.value) {
				lastActive.fileinput.setAttribute('required', true);
				lastActive.fileinput.validate?.();
				if (activePickers.length > 1) {
					setTimeout(() => {
						lastActive.fileinput.removeAttribute('required');
					}, 300);
				}
			} else {
				lastActive.fileinput.setAttribute('required', true);
				firstNext.filepicker.classList.remove('t-hidden');
				if (length === 1) {
					this._addButton.classList.add('t-hidden');
				}
			}
		} else {
			this._addButton.classList.add('t-hidden');
		}
	}
}